import {
    Button,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    Select,
    Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import usePaymentContext from './hook/usePaymentContext'
import { useCallback, useMemo } from 'react'
import PaymentMainSection from './PaymentMainSection'
import { mapPaymentTypeName } from 'components/MapPaymentIcon/mapPaymentIcon'

function PaymentDialogTablet() {
    const { t } = useTranslation()

    const {
        paymentTypeLists,
        selectedPaymentType,
        onSelectPaymentType,
        onEnterAddTipsMode,
        onExitAddTipsMode,
        addTipsMode,
        isReadyToProceedPayment,
        onSubmitPayment,
        isAddTipsEnabled,
        onSetSplitPayment,
        expectAmount,
    } = usePaymentContext()
    const onClickSplit = useCallback(() => {
        onSetSplitPayment(true)
    }, [onSetSplitPayment])
    const onClickAddTipsButton = useMemo(
        () => (addTipsMode ? onExitAddTipsMode : onEnterAddTipsMode),
        [addTipsMode, onExitAddTipsMode, onEnterAddTipsMode],
    )

    return (
        <>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        alignSelf: 'center',
                    }}
                >
                    {t('finish.label.payment')}
                </Typography>

                <Select
                    color="primary"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPaymentType?.paymentSettingID ?? ''}
                    onChange={(e) => {
                        onSelectPaymentType(e.target.value as string)
                    }}
                    sx={{
                        backgroundColor: (t) => t.palette.topside.paper,
                        width: 200,
                    }}
                >
                    {paymentTypeLists.map((m) => (
                        <MenuItem
                            disabled={m.disabled(expectAmount.toNumber())}
                            value={m.paymentSettingID}
                        >
                            {mapPaymentTypeName(m.paymentTypeID, true, {
                                paymentSetting: m,
                            })}
                        </MenuItem>
                    ))}
                </Select>
            </DialogTitle>

            <DialogContent>
                <Grid container justifyContent={'space-between'} pb={1}>
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            onClick={onClickSplit}
                            disabled={!isReadyToProceedPayment}
                        >
                            {t('finish.button.split_payment')}
                        </Button>
                    </Grid>

                    {isAddTipsEnabled && (
                        <Grid item>
                            <Button
                                variant={addTipsMode ? 'contained' : 'outlined'}
                                color="primary"
                                fullWidth
                                onClick={onClickAddTipsButton}
                                disabled={!isReadyToProceedPayment}
                            >
                                {t('finish.button.add_tips')}
                            </Button>
                        </Grid>
                    )}
                </Grid>
                <PaymentMainSection onSubmitPayment={onSubmitPayment} />
            </DialogContent>
        </>
    )
}

export default PaymentDialogTablet
